var _circle, _circle2, _path, _circle3, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    fill: "url(#paint0_linear_3128_138263)",
    stroke: "url(#paint1_linear_3128_138263)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.833,
    cy: 24.1667,
    r: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 18.5C18.0546 18.5 20.6668 21.1115 20.667 24.333L20.6592 24.6338C20.5028 27.7158 17.9539 30.167 14.833 30.167L14.5332 30.1592C11.451 30.003 9 27.454 9 24.333C9.00018 21.1116 11.6116 18.5002 14.833 18.5ZM14.833 20C12.44 20.0002 10.5002 21.94 10.5 24.333C10.5 26.7261 12.4399 28.6668 14.833 28.667C17.2262 28.667 19.167 26.7262 19.167 24.333C19.1668 21.9399 17.2261 20 14.833 20Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 31.333 22.667)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.834 18.5C26.6124 18.5 24.0002 21.1115 24 24.333L24.0078 24.6338C24.1642 27.7158 26.7131 30.167 29.834 30.167L30.1338 30.1592C33.216 30.003 35.667 27.454 35.667 24.333C35.6668 21.1116 33.0554 18.5002 29.834 18.5ZM29.834 20C32.227 20.0002 34.1668 21.94 34.167 24.333C34.167 26.7261 32.2271 28.6668 29.834 28.667C27.4408 28.667 25.5 26.7262 25.5 24.333C25.5002 21.9399 27.4409 20 29.834 20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.666 24.333L23.9993 24.333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 14.3965H34.833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3128_138263",
    x1: 39.16,
    y1: 7.46261e-7,
    x2: -4.36141,
    y2: 19.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3128_138263",
    x1: 9.24,
    y1: -2.46189e-8,
    x2: 4.90789,
    y2: 42.0106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.4833d8e24e47b2fd268d20f1fc61c98a.svg";
export { ForwardRef as ReactComponent };